import { ShieldAlert } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";

const SexCrimes = () => {
  const mainContent = (
    <div className="prose prose-lg max-w-none">
      <h2 className="text-3xl font-bold mb-6">Protecting Your Freedom and Reputation</h2>
      <p className="text-xl text-muted-foreground mb-8">
        Being charged with a sex offense is one of the most serious—and stigmatizing—legal situations anyone can face. Even a mere accusation can impact your relationships, job, housing, and reputation. If convicted, you may face prison, mandatory sex offender registration, and a lifetime of consequences.
      </p>

      <h3 className="text-2xl font-bold mb-4">Sex Crime Charges We Defend</h3>
      <ul className="list-disc pl-6 mb-6">
        <li>Sexual assault and aggravated sexual assault</li>
        <li>Indecency with a child</li>
        <li>Child pornography possession or distribution</li>
        <li>Online solicitation of a minor</li>
        <li>Prostitution and solicitation</li>
        <li>Public lewdness and indecent exposure</li>
      </ul>

      <h3 className="text-2xl font-bold mb-4">Our Defense Approach</h3>
      <p className="mb-6">
        We investigate allegations thoroughly, challenge forensic evidence, question witness testimony, protect your constitutional rights, negotiate for reduced charges when possible, and prepare for trial when necessary.
      </p>

      <h3 className="text-2xl font-bold mb-4">Consequences of Conviction</h3>
      <ul className="list-disc pl-6 mb-8">
        <li>Lengthy prison sentences</li>
        <li>Lifetime sex offender registration</li>
        <li>Housing and employment restrictions</li>
        <li>Loss of parental rights</li>
        <li>Permanent criminal record</li>
        <li>Deportation for non-citizens</li>
      </ul>
    </div>
  );

  return (
    <GenericPracticePage
      title="Sex Crimes Defense"
      subtitle="Aggressive defense for sex crime allegations in Texas"
      icon={<ShieldAlert className="h-20 w-20 mx-auto mb-6 text-accent" />}
      mainContent={mainContent}
    />
  );
};

export default SexCrimes;
